import { render, staticRenderFns } from "./LdChangePasswordBanner.vue?vue&type=template&id=94d8fa42&scoped=true&lang=pug"
import script from "./LdChangePasswordBanner.vue?vue&type=script&lang=js"
export * from "./LdChangePasswordBanner.vue?vue&type=script&lang=js"
import style0 from "./LdChangePasswordBanner.vue?vue&type=style&index=0&id=94d8fa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d8fa42",
  null
  
)

export default component.exports